/**
 * Block renderer router — maps `block_type` to a component.
 * New block types should register here.
 */
import Hero from './Hero';
import StatStrip from './StatStrip';
import Heading from './Heading';
import Subheading from './Subheading';
import Paragraph from './Paragraph';
import FeatureList from './FeatureList';
import CTA from './CTA';
import Mockup from './Mockup';
import PageLinks from './PageLinks';
import Quote from './Quote';
import Divider from './Divider';

export const BLOCK_REGISTRY = {
  hero: Hero,
  stat_strip: StatStrip,
  heading: Heading,
  subheading: Subheading,
  paragraph: Paragraph,
  feature_list: FeatureList,
  cta: CTA,
  mockup: Mockup,
  page_links: PageLinks,
  quote: Quote,
  divider: Divider,
};

export const BLOCK_TYPES = Object.keys(BLOCK_REGISTRY);

export function getBlockComponent(type) {
  return BLOCK_REGISTRY[type] || null;
}
